
import React from 'react';
import GasConsumptionAreaChart from './GasConsumptionAreaChart';

const GasConsumptionTab = () => {
  return (
    <div className="space-y-6">
      <GasConsumptionAreaChart />
    </div>
  );
};

export default GasConsumptionTab;
